import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTenantsDataAction } from "../actions/adminPermissionsAction";
import { sbaAxios } from "../utils/sbaAxios";
import { insertUpdateTenant, DeleteTenant } from "../../config/apiConfig";
import { AgGridReact } from "ag-grid-react";
import { Modal } from "react-bootstrap";
import { SBADrawer } from "../UiComponents/SBADrawer";
import { ToastContainer, toast } from 'react-toastify';
import { SBAAGgrid } from '../UiComponents/SBAAGgrid';
import {Image } from "react-bootstrap";
import { SBNotify } from "../utils/sbNotify";
import SampleProfile from "../../components/investor/investorDetails/sampleImage/ProfileImage.png"
export const Tenant = () => {

  const [render, setRender] = useState(true);
  const [newTenantId, setNewTenantId] = useState("");
  const [newTenantName, setNewTenantName] = useState("");
  const [newGuid, setNewGuid] = useState("");
    const [showDrawer, setshowDrawer] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [TenantId, setTenantId] = useState();
    const [dataUri, setDataUri] = useState('');
    const [base64Data, setBase64Data] = useState(null);
    const ColumnFilteroption = false;

  const dispatch = useDispatch();

  const Gstate =
  useSelector((state) => {
    return state;
  }) || {};

  const tenantsData = Gstate?.AdminPermissions?.TenantData || [];

  useEffect(() => {
    dispatch(getTenantsDataAction());
  }, [render]);

  const AddModeDrawer = () => {
    setNewTenantId("");
    setNewGuid("");
    setNewTenantName("");
    setshowDrawer(true);
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const maxSizeKB = 200; // Maximum file size in KB

    if (file) {
        // Check the file size
        if (file.size > maxSizeKB * 1024) { // Convert KB to bytes
            // File size exceeds the limit
            SBNotify({ type: "error", Msg: "File size exceeds 200 KB limit." });
            return;
        }

        // File size is within the limit, proceed with reading the file
        const reader = new FileReader();
        reader.onload = function () {
            if (reader.result) {
                const arrayBuffer = reader.result;
                const base64String = arrayBufferToBase64(arrayBuffer);
                setBase64Data(base64String);
                if (base64String) {
                    setDataUri(`data:image/png;base64,${base64String}`);
                }
            }
        };
        reader.readAsArrayBuffer(file);
    }
};

const arrayBufferToBase64 = (arrayBuffer) => {
  const binary = [];
  const bytes = new Uint8Array(arrayBuffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
      binary.push(String.fromCharCode(bytes[i]));
  }
  return btoa(binary.join(''));
};
    const handleAddTenant = async (type) => {
    const data = {
      "TenantId":newTenantId == "" ? 0 : newTenantId,
      "TenantName":newTenantName,
      "TenantImage":base64Data,
      "GUID":newGuid
    }    
    if(newTenantName)
    {
        try {
            
            await sbaAxios({
                url: `${insertUpdateTenant}`,
                method: 'post',
                data: data,
            }).then(response => {
        if(response===-9999)
        {
            toast.warning("Tenant Name Already Exists", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
        }
       else if (response>=0) {
            closeDrawer();
            toast.success("Tenant Saved Successfully", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
          setRender(!render);
          }
        })
      } catch (error) {
        console.error("Error updating tenant:", error);
      }
    }
    else 
    {
           toast.warning("Please Fill the Tenant Name", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
    }
   
   
  };
  const closeDrawer = () => {
    setshowDrawer(false);
  };

  const EditButtonRenderer = (props) => {
    const tenantData = props.data;


    const EditModeDrawer = () => {
      onEditButtonClick(tenantData);
    };

    return (
      <div className="actions-cell">
        <i
          className="fas fa-edit"
          style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
          onClick={EditModeDrawer}
        ></i>
      </div>
    );
  };

  const onEditButtonClick = (tenantData) => {
    setNewTenantId(tenantData.TenantId);
    setNewTenantName(tenantData.TenantName);
    const dataURI=tenantData?.TenantImage ? `data:image/png;base64,${tenantData?.TenantImage}` : null
    setDataUri(dataURI);
    setBase64Data(tenantData.TenantImage);
    setNewGuid(tenantData.GUID);
    setshowDrawer(true);
  };
   

    const DeleteButtonRenderer = (props) => {
    const tenantId = props.data.TenantId;
      const handleDeleteClick = () => {
          setShowModal(true);
          setTenantId(tenantId);
      
    };
      
    return (
      <div className="actions-cell">
        <i
          className="fas fa-trash"
          style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
          onClick={handleDeleteClick}
        ></i>
      </div>
    );
    };

    const closeModal = () => {
        setShowModal(false);
    }

    const onDeleteTenant = () => {
        
        setShowModal(false);
        sbaAxios({
            url: `${DeleteTenant}${TenantId}`,
            method: 'get',
        }).then(response => {        
            if (response === -4444) {
                closeModal();
                toast.error("Delete Failed, Users Mapped with this Tenant", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            }
            else if (response === -3333)
                {
                closeModal();
                toast.error("Delete Failed, Services Mapped with this Tenant", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            }
            else {
                closeModal();
                toast.success("Tenant Delete Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
    setTimeout(() => {
        dispatch(getTenantsDataAction());
    }, 100);

}
     })
      .catch(error => {
                console.error('Error deleting data:', error);
       });      
    }

  const tenantsGridRowData = Array.isArray(tenantsData)
    ? tenantsData.map((row) => {
        const rowDataItem = {
          TenantId: row.TenantId,
          TenantName: row.TenantName,
          TenantImage: row.TenantImage
        };
        return rowDataItem;
      })
    : [];

  const listofTenantsColumnDefs = [
    { headerName: "Tenant Name", field: "TenantName" },
    {
      headerName: "Edit",
      field: "Edit",
      cellRenderer: EditButtonRenderer,
      maxWidth: 100,
    },
    {
      headerName: "Delete",
      field: "Delete",
      maxWidth: 100,
      cellRenderer: DeleteButtonRenderer,
    },
  ];

  return (
    <>
        <div className="row flex-wrap">
          <div className="header-container m-2 fs-12 col-lg-6">
            <b> Available Tenants </b>
            <button className="p-sm-btn mx-1" onClick={AddModeDrawer}>
              <i className="fa-solid fa-plus" /> Add
            </button>
          </div>
          <div className="ag-theme-alpine m-1 col-lg-6" style={{ height: 550 }}>
                  {SBAAGgrid(listofTenantsColumnDefs, tenantsGridRowData, ColumnFilteroption)}
          </div>
        </div>
      <SBADrawer open={showDrawer} setOpen={setshowDrawer} close={false} title={'Add / Update Tenant'}>
      <div>           
            <label className="header-container m-1"><b>Tenant Name</b></label>
            <div>
              <input 
                id="TenantName"
                className="form-control w-75"
                type="text"
                value={newTenantName}
                onChange={(e) => setNewTenantName(e.target.value)}
              />
            </div>
            <br></br>
                          <div className="row ">
                              <div className="col">
                                  <Image src={dataUri ? dataUri : SampleProfile}
                                      rounded
                                      style={{ width: "300px" , height:"100px"}} />
                              </div>
                              
                          </div>
                          <div className="mb-4 fileValue" style={{ paddingLeft: "320px", marginTop: "-20px" }}>
                              <input
                                  id="fileInput"
                                  type="file"
                                  accept=".png, .jpg, .jpeg, image/*"
                                  onChange={handleFileChange}
                              />
                          </div>

                     
            <br></br>
            <div className="mt-4">
            <button className="s-sm-btn mx-1" onClick={closeDrawer}>
            Cancel
          </button>
          <button className="p-sm-btn mx-1" onClick={()=>handleAddTenant('add')}>
            Save
          </button>
            </div>
          </div>
          </SBADrawer>

          { <Modal show={showModal}>
              <Modal.Header closeButton onClick={closeModal}>
                  <Modal.Title>Do you want to delete the selected Tenant?</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  <p>The selected Tenent will be deleted permanently. Are you sure?</p>
              </Modal.Body>
              <Modal.Footer>
                  <button className="s-sm-btn mx-1" onClick={closeModal} > Cancel</button>
                  <button className='p-sm-btn mx-1' onClick={onDeleteTenant} >
                      Yes
          </button>
              </Modal.Footer>
          </Modal> }
    </>
  );
};
